import * as t from './types'

export const initialState: t.State = {
  createModalOpen: false,
  editingItem: undefined,
}

export const reducer = (s: t.State = initialState, a: t.Actions): t.State => {
  switch (a.type) {
    case 'ITEMS/toggle_create_modal':
      return { ...s, createModalOpen: !s.createModalOpen }
    case 'ITEMS/open_edit_modal':
      return { ...s, editingItem: a.payload }
    case 'ITEMS/close_edit_modal':
      return { ...s, editingItem: undefined }
    default:
      return s
  }
}
